import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import api from 'redux/api/methods';

import { TMarketResponse } from '../market/type';

import {
  checkSportsMarkets,
  failureFetchGraphMarket,
  fetchGraphMarket,
  successCheckSportsMarkets,
  successFetchGraphMarket
} from './index';

function* getGraphMarketWorker(action: ReturnType<typeof fetchGraphMarket>) {
  try {
    const response: TMarketResponse = yield call(api.marketGraph.getSelections, action.payload);

    yield put(successFetchGraphMarket(response));
  } catch (error: any) {
    yield put(failureFetchGraphMarket(error));
  }
}

function* getIsActiveMarketsWorker(action: ReturnType<typeof checkSportsMarkets>) {
  try {
    const response: Record<string, boolean> = yield call(api.checkSportsMarkets, action.payload.marketIds);
    yield put(successCheckSportsMarkets(response));
  } catch (error: any) {}
}

export default function* saga() {
  yield all([
    takeLatest(fetchGraphMarket.type, getGraphMarketWorker),
    takeEvery(checkSportsMarkets.type, getIsActiveMarketsWorker)
  ]);
}
